import { render, staticRenderFns } from "./agreements_warnings.vue?vue&type=template&id=557dbac6"
import script from "./agreements_warnings.vue?vue&type=script&lang=js"
export * from "./agreements_warnings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports